import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { DATAFLUIDES_THEME } from 'styles/DATAFLUIDES_THEME';

export const CustomThemeProvider = ({ children }) => (
  <ThemeProvider theme={DATAFLUIDES_THEME}>
    {children}
  </ThemeProvider>
);
